// src/api/mappers/buildEngineStory.js — v8.7.1 POLISHED
// FIX: total приходит как число 8383.72 → показывалось "€8383.72 prevented"
// Теперь Math.round → "€8384 prevented" (единообразно с PreventedLossCard)

export function buildEngineStory(risk, prevented) {
  if (!risk.engineOnline) {
    return "— Engine data unavailable";
  }

  const lastHigh = risk.lastRiskEvent;
  // FIX: округляем до целого
  const total = typeof prevented.total30d === "number"
    ? Math.round(prevented.total30d)
    : prevented.total30d;

  if (lastHigh && total > 0) {
    const date  = new Date(lastHigh.date);
    const month = date.toLocaleString("en-US", { month: "short" });
    const day   = date.getDate();
    return `⚡ Risk spike (${month} ${day}) → Engine acted → €${total} prevented`;
  }

  if (!lastHigh && total === 0) {
    return "✓ No risk events in last 30 days · Budget stable";
  }

  if (!lastHigh && total > 0) {
    return `Engine acted → €${total} prevented`;
  }

  return null;
}
